import { connect } from 'react-redux';

const mapStateToProps = (ownerGuidProp, state, ownProps) => {
  const { contact } = state.restricted;
  const ownerGuid = ownProps[ownerGuidProp];
  const recentsProxy = contact.recent_contacts_meta_proxy;
  let recentContactIds = [];
  if (recentsProxy && ownerGuid && recentsProxy[ownerGuid]) {
    recentContactIds = recentsProxy[ownerGuid];
  }
  return {
    recentContactIds,
  };
};

export default function(Component, ownerGuidProp = 'ownerGuid') {
  return connect(
    mapStateToProps.bind(null, ownerGuidProp),
    null
  )(Component);
}



// WEBPACK FOOTER //
// ./src/connectHOCs/Contacts/RecentContacts.js